import styled from "styled-components";
import { ReactComponent as ArrowDown } from "@svg/icon-arrow-down.svg";

export const Arrow = styled(ArrowDown)`
  transform: rotate(-90deg);
  height: 20px;
`;
